import { render, staticRenderFns } from "./ProlongsBlock.vue?vue&type=template&id=ac77bd20"
import script from "./ProlongsBlock.vue?vue&type=script&lang=js"
export * from "./ProlongsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports